// extracted by mini-css-extract-plugin
export default {"logo":"navbar_logo__fn2cn","nav-container":"navbar_nav-container__PRIBX","links":"navbar_links__ftouA"};